// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: GitHub-flavoured Markdown tables, read a row at a time, for the views that draw a table
// with pictures in it themselves (an agent's reply, a Markdown document such as a pull request's
// description): chat Markdown draws text tables but no pictures.

export type CellAlign = 'left' | 'center' | 'right' | null;

const DELIMITER_CELL = /^\s*:?-+:?\s*$/;

/** A table row's cells: the outer pipes dropped, `\|` and pipes inside code kept in their cell. */
export function tableCells(line: string): Array<string> {
	let row = line.trim();
	if (row.startsWith('|')) row = row.slice(1);
	if (row.endsWith('|') && !row.endsWith('\\|')) row = row.slice(0, -1);
	const cells: Array<string> = [];
	let cell = '';
	let code = 0;
	for (let at = 0; at < row.length; at++) {
		const char = row[at];
		if (char === '\\' && row[at + 1] === '|') {
			cell += '|';
			at++;
			continue;
		}
		if (char === '`') {
			let run = 1;
			while (row[at + run] === '`') run++;
			code = code === 0 ? run : code === run ? 0 : code;
			cell += row.slice(at, at + run);
			at += run - 1;
			continue;
		}
		if (char === '|' && code === 0) {
			cells.push(cell.trim());
			cell = '';
			continue;
		}
		cell += char;
	}
	cells.push(cell.trim());
	return cells;
}

export function delimiterRow(line: string): Array<CellAlign> | null {
	if (!line.includes('-')) return null;
	const cells = tableCells(line);
	if (!cells.every((cell) => DELIMITER_CELL.test(cell))) return null;
	return cells.map((cell) => {
		const left = cell.startsWith(':');
		const right = cell.endsWith(':');
		return left && right ? 'center' : right ? 'right' : left ? 'left' : null;
	});
}
